import {useFormik} from "formik";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import Select from "react-select";

const styleHiddenInput = {
  width: 1,
  height: 1,
  padding: 0,
  margin: 0,
  border: 0,
  outline: "none",
  position: "absolute",
  bottom: 0,
  left: "2rem",
};

const DialogFormCommitments = props => {
  const {
    open,
    control,
    findings,
    add,
    edit,
    commitment,
    responsible,
    isPreview,
  } = props;

  const [selectedUser, setSelectedUser] = useState(null);

  const handleSubmit = data => {
    if (commitment) edit(data, commitment.idCompromiso);
    else add(data);
    control(false);
  };

  const formik = useFormik({
    initialValues: {
      HallazgoId: "",
      Compromiso: "",
      Requiere: "",
      Responsable: "",
      eess: "",
      FechaControl: moment().format("YYYY-MM-DD"),
    },
    onSubmit: values => {
      handleSubmit(values);
      formik.resetForm();
    },
  });

  const descriptionShort = desc => {
    const descAux = desc || "";
    return descAux.length > 50 ? descAux.slice(0, 50) + "..." : descAux;
  };

  useEffect(() => {
    formik.setFieldValue("Responsable", selectedUser?.value || "");
  }, [selectedUser]);

  useEffect(() => {
    if (!commitment) return;
    formik.setFieldValue("Compromiso", commitment.Compromiso);
    formik.setFieldValue("Responsable", commitment.Responsable);
    formik.setFieldValue("Requiere", commitment.Requiere);
    formik.setFieldValue("FechaControl", commitment.FechaControl);
    formik.setFieldValue("eess", commitment.eess);
    formik.setFieldValue("HallazgoId", commitment.HallazgoId);

    const user = responsible.find(user => {
      return Number(user.value) === Number(commitment.Responsable);
    });
    setSelectedUser(user);
  }, [commitment, responsible]);

  useEffect(() => {
    if (!open) {
      formik.resetForm();
      setSelectedUser(null)
    }
  }, [open]);

  return (
    <Modal
      show={open}
      onHide={() => control(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Compromisos
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} id="form-finding">
          <div className="row">

            <div className="col-12 mb-3">
              <label className="form-label">Hallazgo <h5 className="text-danger m-0 d-inline">*</h5></label>
              <select
                className="form-select"
                name="HallazgoId"
                value={formik.values.HallazgoId}
                onChange={formik.handleChange}
                disabled={isPreview}
                required
              >
                <option value="" hidden>
                  {findings.length > 0
                    ? "Seleccione..."
                    : "No existen Hallazgos..."}
                </option>
                {findings.map(finding => (
                  <option key={finding.HallazgoId} value={finding.HallazgoId}>
                    {descriptionShort(finding.Observacion)}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12 col-md-6 mb-3 position-relative">
              <label className="form-label">Responsable <h5 className="text-danger m-0 d-inline">*</h5></label>
              <input
                type="text"
                value={formik.values.Responsable}
                onChange={() => null}
                style={styleHiddenInput}
                required
              />
              <Select
                value={selectedUser}
                onChange={setSelectedUser}
                options={responsible}
                placeholder="Busque y seleccione..."
                isDisabled={isPreview}
                required
              />
            </div>

            <div className="col-12 col-md-6 mb-3 position-relative">
              <label className="form-label">Email EE.SS <h5 className="text-danger m-0 d-inline"></h5></label>
              <input
                type="email"
                className="form-control"
                name="eess"
                value={formik.values.eess}
                onChange={formik.handleChange}
                disabled={isPreview}
                placeholder="empresa@email.com"

              />
            </div>


            <div className="col-12 mb-3">
              <label className="form-label">Compromiso <h5 className="text-danger m-0 d-inline">*</h5></label>
              <textarea
                rows="2"
                className="form-control"
                name="Compromiso"
                value={formik.values.Compromiso}
                onChange={formik.handleChange}
                placeholder="Escriba aquí."
                disabled={isPreview}
                required
              />
            </div>

            <div className="col-12 mb-3">
              <div className="form-check mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="Requiere"
                  value={formik.values.Requiere}
                  checked={formik.values.Requiere}
                  onChange={formik.handleChange}
                  id="checkControl"
                  disabled={isPreview}
                />
                <label className="form-check-label" htmlFor="checkControl">
                  Requiere control
                </label>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">Fecha compromiso</label>
              <input
                type="date"
                className="form-control"
                name="FechaControl"
                value={formik.values.FechaControl}
                onChange={formik.handleChange}
                disabled={isPreview}
                required
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      {!isPreview && (
        <Modal.Footer>
          <button type="submit" form="form-finding" className="btn btn-success">
            Guardar Compromiso
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default DialogFormCommitments;
